import { Channels } from '@/core/constants/channelConstants';
import { Roles, MetaRoles } from '@/core/constants/roleConstants';
import { BasePolicy } from '../BasePolicy';

/**
 * ManagedOrderPolicy
 *
 * Unified policy for the order management module.
 * An order management policy governs access to order management views
 * and features for users who manage or supervise orders (sellers, managers,
 * regional managers, directors, etc.).
 *
 * This policy exposes `canList(metaRole)` to validate list access based
 * on the route's `metaRole`.
 */
export class OrderManagementPolicy extends BasePolicy {
  static canList(metaRole) {
    const roleMap = {
      [MetaRoles[Roles.SELLER]]: [
        Roles.SELLER,
        Roles.MANAGER,
        Roles.SUB_MANAGER,
        Roles.REGIONAL_MANAGER,
        Roles.SUB_DIRECTOR,
        Roles.DIRECTOR,
        Roles.ADMIN,
        Roles.SUPER_USER,
      ],
      [MetaRoles[Roles.MANAGER]]: [
        Roles.MANAGER,
        Roles.SUB_MANAGER,
        Roles.REGIONAL_MANAGER,
        Roles.SUB_DIRECTOR,
        Roles.DIRECTOR,
        Roles.ADMIN,
        Roles.SUPER_USER,
      ],
      [MetaRoles[Roles.REGIONAL_MANAGER]]: [
        Roles.REGIONAL_MANAGER,
        Roles.SUB_DIRECTOR,
        Roles.DIRECTOR,
        Roles.ADMIN,
        Roles.SUPER_USER,
      ],
      [MetaRoles[Roles.SUB_DIRECTOR]]: [
        Roles.SUB_DIRECTOR,
        Roles.DIRECTOR,
        Roles.ADMIN,
        Roles.SUPER_USER,
      ],
      [MetaRoles[Roles.DIRECTOR]]: [
        Roles.SUB_DIRECTOR,
        Roles.DIRECTOR,
        Roles.ADMIN,
        Roles.SUPER_USER,
      ],
    };

    const roles = roleMap[metaRole] || [];
    const channels = [Channels.WHOLESALER, Channels.RETAIL];
    return this.hasAnyRole(roles) && this.hasAnyChannel(channels);
  }
}

export default OrderManagementPolicy;
